export default "__VITE_ASSET__lg0klXvn__"